module.exports = __webpack_public_path__ + "static/media/屋顶融雪除冰2.f7529bb5.jpg";